import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ApiError } from '../lib/api';
import { keys } from '../lib/queries';
import { useSystemThemeSync } from '../lib/theme';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // Não insiste em erro de cliente (4xx); tenta de novo só falha de rede/servidor.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

// Sessão expirou em qualquer consulta: limpa o usuário e a tela de entrada assume.
queryClient.getQueryCache().subscribe((event) => {
  const err = event.query.state.error;
  if (
    event.type === 'updated' &&
    err instanceof ApiError &&
    err.status === 401 &&
    event.query.queryKey[0] !== keys.me[0]
  ) {
    queryClient.setQueryData(keys.me, null);
  }
});

export function App() {
  useSystemThemeSync();
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
